import { registerAdapter } from './registry'
import { ZohoInventoryAdapter } from './providers/zoho/ZohoInventoryAdapter'

// Register default provider adapter(s)
registerAdapter('zoho', new ZohoInventoryAdapter())

